const actions = {
    READ_TERMS_REQUEST: 'READ_TERMS_REQUEST',
    READ_TERMS_SUCCESS: 'READ_TERMS_SUCCESS',
    READ_TERMS_ERROR: 'READ_TERMS_ERROR',
    ARCHIVE_TERM_REQUEST: 'ARCHIVE_TERM_REQUEST',
    ARCHIVE_TERM_SUCCESS: 'ARCHIVE_TERM_SUCCESS',
    ARCHIVE_TERM_ERROR: 'ARCHIVE_TERM_ERROR',
    DELETE_TERM_REQUEST: 'DELETE_TERM_REQUEST',
    DELETE_TERM_SUCCESS: 'DELETE_TERM_SUCCESS',
    DELETE_TERM_ERROR: 'DELETE_TERM_ERROR',
    READ_TERM_REQUEST: 'READ_TERM_REQUEST',
    READ_TERM_SUCCESS: 'READ_TERM_SUCCESS',
    READ_TERM_ERROR: 'READ_TERM_ERROR',
    POPULATE_TERM: 'POPULATE_TERM',
    UPDATE_TYPE: 'UPDATE_TYPE',
    SET_INTEREST_ON: 'SET_INTEREST_ON',
    CREATE_TERM_REQUEST: 'CREATE_TERM_REQUEST',
    CREATE_TERM_SUCCESS: 'CREATE_TERM_SUCCESS',
    CREATE_TERM_ERROR: 'CREATE_TERM_ERROR',
    UPDATE_TERM_REQUEST: 'UPDATE_TERM_REQUEST',
    UPDATE_TERM_SUCCESS: 'UPDATE_TERM_SUCCESS',
    UPDATE_TERM_ERROR: 'UPDATE_TERM_ERROR',

    readTerms: payload => ({
        type: actions.READ_TERMS_REQUEST,
        payload,
    }),
    archiveTerm: (id, payload) => ({
        type: actions.ARCHIVE_TERM_REQUEST,
        id,
        payload,
    }),
    deleteTerm: id => ({
        type: actions.DELETE_TERM_REQUEST,
        id,
    }),
    readTerm: id => ({
        type: actions.READ_TERM_REQUEST,
        id,
    }),
    populateTerm: (payload, reset = false) => ({
        type: actions.POPULATE_TERM,
        payload,
        reset,
    }),
    updateType: (payload, reset = false) => ({
        type: actions.UPDATE_TYPE,
        payload,
        reset,
    }),
    setInterestOn: (interestOn, reset = false) => ({
        type: actions.SET_INTEREST_ON,
        interestOn,
        reset,
    }),
    createTerm: payload => ({
        type: actions.CREATE_TERM_REQUEST,
        payload,
    }),
    updateTerm: (id, payload) => ({
        type: actions.UPDATE_TERM_REQUEST,
        id,
        payload,
    }),
};
export default actions;
